import type { FunctionComponent } from 'react';

import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import SettingsPage from '../../shared/settings/SettingsPage';
import * as permissions from '../shared/permissions';
import type { RouterProps } from '../../../types';

type Props = RouterProps;

/**
 * OrganizationProjectSettingsContainer is the top-level wrapper component for
 * all the organization-level project settings pages.
 */
const OrganizationProjectSettingsContainer: FunctionComponent<Props> = ({ children, location }) => (
  <SidebarNavLayout>
    <SidebarNavLayout.Nav pathname={location.pathname}>
      <SidebarNavLayout.NavHeading>
        Projects
      </SidebarNavLayout.NavHeading>
      <SidebarNavLayout.NavItem to="/account/settings/projects/general" activeKey="general">
        General
      </SidebarNavLayout.NavItem>
      {permissions.shouldDisplayProjectIssueSettings() && (
        <SidebarNavLayout.NavItem to="/account/settings/projects/issues" activeKey="issues">
          Issue Policies
        </SidebarNavLayout.NavItem>
      )}
      {permissions.shouldDisplayProjectNotificationSettings() && (
        <SidebarNavLayout.NavItem to="/account/settings/projects/notifications" activeKey="notifications">
          Notifications
        </SidebarNavLayout.NavItem>
      )}
      {permissions.shouldDisplayProjectUpdateHookSettings() && (
        <SidebarNavLayout.NavItem to="/account/settings/projects/hooks" activeKey="hooks">
          Hooks
        </SidebarNavLayout.NavItem>
      )}
    </SidebarNavLayout.Nav>
    <SidebarNavLayout.Content>
      <SettingsPage>
        {children}
      </SettingsPage>
    </SidebarNavLayout.Content>
  </SidebarNavLayout>
);

export default OrganizationProjectSettingsContainer;
